import { compose } from 'redux';
import { connect } from 'react-redux';
import selectors from '../rootSelectors';
import RANView from './RANView';
import AvatarView from '../common/avatar/avatarView';
import withAvatar from '../common/avatar/withAvatar';
import { RAN } from '../constants/measure';
import { ITEMS } from '../constants/assessmentItemType';
import { narrateReset, stopAudio } from '../common/audio/audioActions';
import {
    unmountScreen, toggleCircleButtons, toggleSecondsTimer, setSecondsTimer,
    blockScreen, unblockScreen,
} from '../common/screen/screenActions';
import { goToStartPage } from '../common/navigation/navigationActions';
import { getMeasureType } from '../common/utils/urlParsers';
import { setPlaylistItemCompleted } from '../common/playlist/playlistActions';
import {
    fetchRANContent, onNextItemResponse, resetItemActiveIndex,
    resetRANSelectedResponses, saveResult,
} from './ranActions';

const mapStateToProps = (state, ownProps) => {
    const measureType = getMeasureType(ownProps.location.pathname);
    return {
        pageType: ITEMS,
        pageLayout: `${RAN.MEASURE} ${measureType} ${ITEMS}`,
        isDataFetched: selectors.getIsRANDataFetched(state, measureType),
        isScreenBlocked: selectors.getIsScreenBlocked(state),
        isScreenGreyedOut: selectors.getIsScreenGreyedOut(state),
        activeItemIndex: selectors.getRANActiveItemIndex(state),
        isNextButtonActive: selectors.getIsNextButtonActive(state),
        isCircleButtonsVisible: selectors.getIsCircleButtonsVisible(state),
        isSecondsTimerVisible: selectors.getIsSecondsTimerVisible(state),
        isSecondsTimerActive: selectors.getIsSecondsTimerActive(state),
        hasActivityTimer: true,
        items: selectors.getRANItems(state, ITEMS),
    };
};

const mapDispatchToProps = (dispatch, ownProps) => {
    const measureType = getMeasureType(ownProps.location.pathname);
    return {
        fetchContent: () => {
            dispatch(fetchRANContent(measureType));
        },
        narrateScreen: () => {
            dispatch(toggleSecondsTimer());
            dispatch(toggleCircleButtons());
            return Promise.resolve();
        },
        activateSecondsTimer: () => {
            dispatch(setSecondsTimer(true));
        },
        onNextItem: (selectedResponse, timeDuration) => dispatch(onNextItemResponse(measureType, selectedResponse, timeDuration)),
        onNext: async () => {
            dispatch(blockScreen());
            await dispatch(saveResult(measureType));
            dispatch(setPlaylistItemCompleted(RAN.MEASURE));
            dispatch(unblockScreen());
            dispatch(goToStartPage());
        },
        cleanup: () => {
            dispatch(stopAudio());
            dispatch(narrateReset());
            dispatch(resetItemActiveIndex());
            dispatch(resetRANSelectedResponses());
            dispatch(unmountScreen());
        },
        goToStartPage: () => {
            dispatch(goToStartPage());
        },
    };
};

const avatarMapStateToProps = () => ({
    position: AvatarView.Position.HIDDEN,
});

const RANItemsContainer = compose(
    connect(mapStateToProps, mapDispatchToProps),
    withAvatar(avatarMapStateToProps),
)(RANView);

export default RANItemsContainer;
